import React from 'react'
import { Link } from 'react-router-dom'
import { Card } from './index'

const List = ({data, bookmark}) => {
  return (
    <div className="w-full">
      {
        data &&
        data.map((d, index) => {
          return (
            <div className="mb-8" key={index}>
              <Link to={`/organization/${d.id ? d.id : '1'}`} className="no-tap-highlight">
                <Card key={index} data={d} bookmark={bookmark}/>
              </Link>
            </div>
          )
        })
      }
    </div>
  )
}

export { List }
